import { render, staticRenderFns } from "./ChooseRecordChooseItem.vue?vue&type=template&id=4b7f9d14&"
import script from "./ChooseRecordChooseItem.vue?vue&type=script&lang=js&"
export * from "./ChooseRecordChooseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports